import { render, staticRenderFns } from "./VueDraggable.vue?vue&type=template&id=b095975a&scoped=true"
import script from "./VueDraggable.vue?vue&type=script&lang=js"
export * from "./VueDraggable.vue?vue&type=script&lang=js"
import style0 from "./VueDraggable.vue?vue&type=style&index=0&id=b095975a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b095975a",
  null
  
)

export default component.exports